"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_cognito_identity_js_1 = require("amazon-cognito-identity-js");
var core_1 = require("@aws-amplify/core");
var logger = new core_1.ConsoleLogger('AWSCognitoProvider');
var AWSCognitoProvider = /** @class */ (function () {
    function AWSCognitoProvider(options) {
        this._config = {};
        this.configure(options);
    }
    AWSCognitoProvider.prototype.configure = function (options) {
        Object.assign(this._config, options);
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, storage = _a.storage;
        this._storage = storage;
        this._storageSync = this._storage && typeof this._storage['sync'] === 'function' ?
            this._storage['sync']() : Promise.resolve();
        if (userPoolId) {
            this._userPool = new amazon_cognito_identity_js_1.CognitoUserPool({
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId
            });
        }
    };
    AWSCognitoProvider.prototype.getProviderName = function () {
        return AWSCognitoProvider.NAME;
    };
    AWSCognitoProvider.prototype.getCategory = function () {
        return 'Auth';
    };
    AWSCognitoProvider.prototype.setSession = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, authenticationFlowType, _keyPrefix, username, tokens, provider, _b, federatedWithIDP, user, userSession, credentials, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this._config, authenticationFlowType = _a.authenticationFlowType, _keyPrefix = _a._keyPrefix;
                        username = params.username, tokens = params.tokens, provider = params.provider, _b = params.federatedWithIDP, federatedWithIDP = _b === void 0 ? {} : _b;
                        user = new amazon_cognito_identity_js_1.CognitoUser({
                            Username: username,
                            Pool: this._userPool,
                            Storage: this._storage
                        });
                        userSession = new amazon_cognito_identity_js_1.CognitoUserSession({
                            IdToken: new amazon_cognito_identity_js_1.CognitoIdToken({ IdToken: tokens.idToken }),
                            AccessToken: new amazon_cognito_identity_js_1.CognitoAccessToken({ AccessToken: tokens.accessToken }),
                            RefreshToken: new amazon_cognito_identity_js_1.CognitoRefreshToken({ RefreshToken: tokens.refreshToken })
                        });
                        // cache information
                        user.setSignInUserSession(userSession);
                        credentials = undefined;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, core_1.Credentials.set(userSession, 'session')];
                    case 2:
                        credentials = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        logger.debug('Failed to get the aws credentials with the tokens provided', e_1);
                        if (federatedWithIDP.errorHandler) {
                            federatedWithIDP.errorHandler(e_1);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, {
                            session: userSession,
                            user: user,
                            credentials: credentials
                        }];
                }
            });
        });
    };
    AWSCognitoProvider.prototype.getSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                logger.debug('tobe implemented');
                return [2 /*return*/, null];
            });
        });
    };
    AWSCognitoProvider.prototype.clearSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                logger.debug('tobe implemented');
                return [2 /*return*/];
            });
        });
    };
    AWSCognitoProvider.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                logger.debug('tobe implemented');
                return [2 /*return*/];
            });
        });
    };
    AWSCognitoProvider.NAME = 'AWSCognito';
    return AWSCognitoProvider;
}());
exports.default = AWSCognitoProvider;
//# sourceMappingURL=AWSCognitoProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/auth/lib/providers/AWSCognitoProvider.js
// module id = 1199
// module chunks = 11